import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'

import { App } from './app/App'
import { notifyOfflineReady, notifyPwaUpdateAvailable } from './services/pwaLifecycle'
import './styles/global.css'

const updateServiceWorker = registerSW({
  immediate: true,
  onOfflineReady() {
    notifyOfflineReady()
  },
  onNeedRefresh() {
    notifyPwaUpdateAvailable(updateServiceWorker)
  },
})

const root = document.querySelector<HTMLDivElement>('#root')

if (!root) {
  throw new Error('Le conteneur racine de Caravan est introuvable.')
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
